import { emptyQuestState, type DailyQuestState, type QuestSlot } from "@core/economy/dailyQuestRules";
import { supabase } from "../lib/supabase";

/** 일일 숙제 슬롯 기록 — slot: 'login'|'vote'|'contribute' */
export async function trackDailyQuestRpc(slot: QuestSlot): Promise<DailyQuestState | null> {
  const { data, error } = await supabase.rpc("track_daily_quest", { p_slot: slot });
  if (error) {
    console.warn("[track_daily_quest]", error.message);
    return null;
  }
  if ((data as any)?.error) return null; // not_authenticated / invalid_slot — 조용히 무시
  return data as DailyQuestState;
}

/** 오늘 숙제 진행 상태 조회 (위젯 표시용) */
export async function fetchTodayQuests(userId: string | null = null): Promise<DailyQuestState | null> {
  let uid = userId;
  if (!uid) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;
    uid = user.id;
  }
  const today = new Date().toISOString().slice(0, 10);
  const { data } = await supabase
    .from("daily_quests")
    .select("slot_login, slot_vote, slot_contribute, completed_at")
    .eq("user_id", uid)
    .eq("date", today)
    .maybeSingle();
  return (data as DailyQuestState) || emptyQuestState();
}
